import React from 'react';
import PropTypes from 'prop-types';
import StepOne from './StepOne';
import StepTitle from './StepTitle';
import StepTwo from './StepTwo';

const getSteps = (locales) => [
  {
    step: StepOne,
    title: locales.admin.createClassName,
  },
  {
    step: StepTwo,
    title: locales.admin.inviteStudentsToJoin,
  },
];
const Steps = ({ stepIndex, onCancel, locales }) => {
  const steps = getSteps(locales);
  const Step = steps[stepIndex].step;
  return (
    <>
      <StepTitle
        currentStepIndex={stepIndex + 1}
        totalSteps={steps.length}
        title={steps[stepIndex].title}
        locales={locales}
      />
      <Step
        stepTitle={steps[stepIndex].title}
        onCancel={onCancel}
        locales={locales}
      />
    </>
  );
};

Steps.propTypes = {
  stepIndex: PropTypes.number,
  // eslint-disable-next-line react/no-unused-prop-types
  nextStep: PropTypes.func,
};
export default Steps;
